import type { DeploymentFacts } from "@karvstokk/config/client";
import { createContext, useContext } from "react";

export const DEPLOYMENT_FACTS_KEY = ["deployment-facts"] as const;

export const DeploymentFactsContext = createContext<DeploymentFacts | null>(
  null,
);

/**
 * The facts, for anything that depends on the chain or the RP ID. Only
 * reachable under `<RequireDeploymentFacts>`, which renders nothing until they have
 * arrived — so a caller never sees a default standing in for an answer.
 */
export function useDeploymentFacts(): DeploymentFacts {
  const facts = useContext(DeploymentFactsContext);
  if (facts === null) {
    throw new Error(
      "useDeploymentFacts is used outside <RequireDeploymentFacts>",
    );
  }
  return facts;
}
